import React, {
    ReactNode,
} from "react";

import SettingsContainer from "../../../../components/theme/settings";

import RequestTypeTable from "./RequestTypesTable";
import CustomFieldsTable from "./CustomFieldsTable";
import useRouting, { useParams } from "../../../../contexts/Routing";

export default function RequestTypes(): ReactNode {
    const { historyPush, Paths } = useRouting();

    const { setting } = useParams(Paths.ADMINISTRATOR_SETTING);

    return (
        <SettingsContainer
            navigation="tabs"
            selectedSectionKey={setting}
            onSectionChanged={key => historyPush(Paths.ADMINISTRATOR_SETTING, { setting: key })}
        >
            <RequestTypeTable />
            <CustomFieldsTable />
        </SettingsContainer>
    );
}
